import type { SpecialtyType } from '@/types/database'

// ─── Platform business rules ─────────────────────────────────────────────────

/** Platform commission percentage charged on each booking. */
export const PLATFORM_FEE_PERCENT = 15

/** Minutes after booking creation during which the slot is held for payment. */
export const BOOKING_LOCK_MINUTES = 15

/** Hours before the lesson start time that qualify for a full refund. */
export const CANCELLATION_FULL_REFUND_HOURS = 24

/** Hours before the lesson start time that qualify for a 50 % refund. */
export const CANCELLATION_HALF_REFUND_HOURS = 2

/** Hours after lesson completion before instructor payout is released. */
export const PAYOUT_WINDOW_HOURS = 48

// ─── Specialty labels ────────────────────────────────────────────────────────

export const SPECIALTY_LABELS: Record<SpecialtyType, string> = {
  iniciantes: 'Para Iniciantes',
  cnh_b: 'CNH Categoria B',
  cnh_a: 'CNH Categoria A',
  direcao_defensiva: 'Direção Defensiva',
  cambio_manual: 'Câmbio Manual',
  cambio_automatico: 'Câmbio Automático',
  estacionamento: 'Estacionamento',
  rodovia: 'Rodovias e Estradas',
}

// ─── Calendar helpers ─────────────────────────────────────────────────────────

/** Portuguese day names indexed 0 (Sunday) → 6 (Saturday). */
export const DAY_OF_WEEK_LABELS: string[] = [
  'Domingo',
  'Segunda-feira',
  'Terça-feira',
  'Quarta-feira',
  'Quinta-feira',
  'Sexta-feira',
  'Sábado',
]

// ─── Lesson duration options ──────────────────────────────────────────────────

export const DURATION_OPTIONS: { value: number; label: string }[] = [
  { value: 60, label: '1 hora' },
  { value: 90, label: '1 hora e 30 minutos' },
  { value: 120, label: '2 horas' },
]

// ─── Lesson package options ───────────────────────────────────────────────────

export const PACKAGE_OPTIONS: { quantity: number; discountPercent: number; label: string; badge: string }[] = [
  { quantity: 3,  discountPercent: 5,  label: 'Pacote 3 aulas',  badge: '5% off' },
  { quantity: 5,  discountPercent: 10, label: 'Pacote 5 aulas',  badge: '10% off' },
  { quantity: 10, discountPercent: 20, label: 'Pacote 10 aulas', badge: '20% off' },
]

/** Duration for a trial lesson in minutes. */
export const TRIAL_DURATION_MINUTES = 30

/** Price multiplier for a trial lesson (50% of the normal rate). */
export const TRIAL_PRICE_MULTIPLIER = 0.5

// ─── Brazilian states ─────────────────────────────────────────────────────────

export const BRAZILIAN_STATES: { value: string; label: string }[] = [
  { value: 'AC', label: 'AC — Acre' },
  { value: 'AL', label: 'AL — Alagoas' },
  { value: 'AP', label: 'AP — Amapá' },
  { value: 'AM', label: 'AM — Amazonas' },
  { value: 'BA', label: 'BA — Bahia' },
  { value: 'CE', label: 'CE — Ceará' },
  { value: 'DF', label: 'DF — Distrito Federal' },
  { value: 'ES', label: 'ES — Espírito Santo' },
  { value: 'GO', label: 'GO — Goiás' },
  { value: 'MA', label: 'MA — Maranhão' },
  { value: 'MT', label: 'MT — Mato Grosso' },
  { value: 'MS', label: 'MS — Mato Grosso do Sul' },
  { value: 'MG', label: 'MG — Minas Gerais' },
  { value: 'PA', label: 'PA — Pará' },
  { value: 'PB', label: 'PB — Paraíba' },
  { value: 'PR', label: 'PR — Paraná' },
  { value: 'PE', label: 'PE — Pernambuco' },
  { value: 'PI', label: 'PI — Piauí' },
  { value: 'RJ', label: 'RJ — Rio de Janeiro' },
  { value: 'RN', label: 'RN — Rio Grande do Norte' },
  { value: 'RS', label: 'RS — Rio Grande do Sul' },
  { value: 'RO', label: 'RO — Rondônia' },
  { value: 'RR', label: 'RR — Roraima' },
  { value: 'SC', label: 'SC — Santa Catarina' },
  { value: 'SP', label: 'SP — São Paulo' },
  { value: 'SE', label: 'SE — Sergipe' },
  { value: 'TO', label: 'TO — Tocantins' },
]
